import React from 'react';
interface OfferLinkProps {
  children: React.ReactNode;
  className?: string;
  ariaLabel?: string;
}
export function OfferLink({
  children,
  className = '',
  ariaLabel = 'Go to the offer section'
}: OfferLinkProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <a href="#offer" onClick={handleClick} aria-label={ariaLabel} className={className} data-id="element-178" data-mp="2w4gbunmmvru7">
      {children}
    </a>;
}